/**
 * cookie key 常量
 */
export const constants = {
  usertoken: 'liblibai_usertoken',
  webid: 'liblibai_webid',
  old_usertoken: 'usertoken',
  old_webid: 'webid',
};
